import { useRef } from 'react';
import styled from 'styled-components';
import { SearchIcon } from '../TipSheetIcons/search-icon';
import { parseKeywords, formatKeywords } from '../../utils/keywordUtils';

const FormWrap = styled.div`
  position: relative;
  width: 100%;
  ${(props) =>
    props.$isActive
      ? 'padding-bottom: 1rem; border-bottom: 1px solid #cccccc;'
      : ''}

  & svg {
    position: absolute;
    right: 0.5rem;
    top: 0.625rem;
  }

  @media (max-width: 768px) {
    display: ${(props) => (!props.$isMobile ? 'none' : 'block')};
  }
`;

const SearchLabel = styled.label`
  display: ${(props) => (props.$isActive ? 'block' : 'none')};
  font-size: 0.75rem;
  font-weight: 600;
  color: #666666;
  text-transform: uppercase;
  margin-bottom: 0.25rem;
`;

const FilterTextBox = styled.input`
  border-radius: 0.25rem;
  border: 1px solid #cccccc;
  text-indent: ${(props) => (props.$isMobile ? '0.5rem' : '0')};
  font-size: 0.875rem;
  line-height: 1.5;
  width: 100%;
  height: 2rem;
  padding: 0 0 0 0.5rem;

  &::placeholder {
    color: #212121;
	  font-size: 0.875rem;
  }
`;

const SearchButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  position: absolute;
  right: 0.25rem;
`;

export const ArchiveKeywordSearch = ({
  setKeywords,
  isMobile = false,
  inputRef,
  onInputChange,
  isActive = false,
}) => {
  const localRef = useRef(null);
  const ref = inputRef || localRef;

  const handleInput = (e) => {
    if (onInputChange) {
      onInputChange(e.target.value);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const rawInput = ref.current.value.trim();
    if (!rawInput) return;

    const inputTokens = parseKeywords(rawInput);
    if (inputTokens.length === 0) {
      ref.current.value = '';
      if (onInputChange) onInputChange('');
      return;
    }

    // Replace existing keywords with the new input tokens (start fresh)
    const updatedKeywords = formatKeywords(inputTokens);
    setKeywords(updatedKeywords);

    // Clear input and notify parent input state
    ref.current.value = '';
    if (onInputChange) onInputChange('');
  };

  return (
    <FormWrap $isMobile={isMobile} $isActive={isActive}>
      <SearchLabel $isActive={isActive} htmlFor="archive-keyword-input">
        Keywords
      </SearchLabel>
      <form onSubmit={handleSubmit} style={{ position: 'relative' }}>
        <FilterTextBox
          ref={ref}
          placeholder="Keywords"
          name="search"
          type="text"
          $isMobile={isMobile}
		  onInput={handleInput}
        />
        <SearchButton type="submit">
          <SearchIcon />
        </SearchButton>
      </form>
    </FormWrap>
  );
}
